/*
 * @Author: 张家林
 * @LastEditors: 张家林
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import remConfig from './config/remConfig.js'
import './config/reset.scss'
import 'vant/lib/index.css'

Vue.config.ignoredElements = ['wx-open-launch-weapp']
// const VConsole = require('vconsole')
// // eslint-disable-next-line
// new VConsole()
console.log('wx',window.wx)


remConfig()

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
